export default "/images/refresh-ccw.svg?f0e1217c1b825cb980e255924d718e86";